import { GenderEnum } from "@repo/core/enums/proposals";

export const inputTypeOptions = [
  {
    value: GenderEnum.MALE,
    label: "Masculino"
  },
  {
    value: GenderEnum.FEMALE,
    label: "Feminino"
  }
];
